import { render, staticRenderFns } from "./synthese.vue?vue&type=template&id=1a4984f0"
import script from "./synthese.vue?vue&type=script&lang=ts"
export * from "./synthese.vue?vue&type=script&lang=ts"
import style0 from "./synthese.vue?vue&type=style&index=0&id=1a4984f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports